'use client';

import { useCallback, useMemo } from 'react';
import { useCookieConsentContext } from '@/contexts/CookieConsentContext';
import type { CookieServiceAttributes } from '@/types/cookie-consent';

/**
 * Cookie service key (API `cookie_services.key`) üzerinden kategori onayı.
 * Kategori adı bileşende hardcode edilmez; servis kaydındaki `category` kullanılır.
 */
export function useCookieServiceAllowed(serviceKey: string): {
  allowed: boolean;
  service: CookieServiceAttributes | null;
  openSettings: () => void;
} {
  const { services, preferences, setShowModal, setShowBanner } = useCookieConsentContext();

  const service = useMemo(
    () => services.find((s) => s.key === serviceKey && s.is_active) ?? null,
    [services, serviceKey]
  );

  const allowed = useMemo(() => {
    if (!service) return false;
    if (service.category === 'necessary') return true;
    if (!preferences?.categories) return false;
    return preferences.categories[service.category] === true;
  }, [service, preferences]);

  const openSettings = useCallback(() => {
    setShowBanner(false);
    setShowModal(true);
  }, [setShowBanner, setShowModal]);

  return { allowed, service, openSettings };
}
